// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.no-inspections[data-v-d7da7c78] {\n  text-align: center;\n  background: #ffffff;\n  position: absolute;\n  height: 100%;\n  margin-left: 320px;\n  width: 1167px;\n}\n.grey-circle[data-v-d7da7c78] {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  margin-top: 109px;\n  background: rgba(217, 217, 217, 0.1);\n}\n.bg[data-v-d7da7c78] {\n  position: absolute;\n}\n", ""]);
// Exports
module.exports = exports;
